import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import HowItWorks3 from "../components/landing/HowItWorks3";
import BookingExample from "../components/landing/BookingExample";
import TrustBlock from "../components/landing/TrustBlock";
import OfferSystem from "../components/OfferSystem";
import CategoryShortcuts from "../components/landing/CategoryShortcuts";
import SpotlightPreview from "../components/landing/SpotlightPreview";
import TalentCta from "../components/landing/TalentCta";
import FinalCta from "../components/FinalCta";
import { useLang } from "../context/LanguageContext";
import { useSEO, buildLocalBusinessJsonLd, buildOrganizationJsonLd, buildWebsiteJsonLd } from "../lib/seo";

/**
 * Startsidan.
 *
 * Ordningen följer de frågor en kund ställer, i den ordning hon ställer dem:
 * vad är det här, hur går det till, har någon gjort det, vågar jag, hur ser en
 * offert ut, vad kan jag boka, vilka är ni. Talangens sektion ligger näst sist,
 * eftersom hon som letar en DJ inte ska mötas av ett rekryteringsbudskap på väg
 * ned, och han som letar jobb ändå läser hela sidan.
 *
 * Tre sektioner ur den gamla sidan ligger inte längre här: ``PainVsPleasure``,
 * ``FeatureSpotlight`` och ``WhyChoose``. De sa samma sak som stegen och
 * trygghetsblocket gör bättre, och en startsida som säger samma sak tre gånger
 * läses inte klart. Filerna är kvar och kan användas på ``/for-organisers``.
 *
 * ``BookingExample`` renderar bara när det finns en verklig kund att citera. Se
 * kommentaren i den filen: ett påhittat omdöme med ett namn under är en falsk
 * recension, inte en platshållare.
 */

const Home = () => {
  const isSv = useLocation().pathname.startsWith("/sv");
  const { setLang } = useLang();
  useEffect(() => { setLang(isSv ? "sv" : "en"); }, [isSv, setLang]);
  useSEO({
    title: isSv ? "Boka verifierade talanger i hela Sverige | Talentsio" : "Book verified talent across Sweden | Talentsio",
    // Beskrivningen lovade tidigare bud "inom 48 timmar". Vi mäter inte
    // svarstid och kan inte styra när en fri yrkesutövare svarar, så löftet är
    // utbytt mot det som är sant och lika säljande: högst fem svar, med pris.
    description: isSv
      ? "Sveriges marknadsplats för talangbokning. Beskriv ditt event gratis och få prissatta offerter från granskade DJ:s, band, komiker och värdar. Högst fem talanger kan svara, så du slipper en full inkorg."
      : "Sweden's talent booking marketplace. Describe your event for free and get priced offers from reviewed DJs, bands, comedians and hosts. At most five talents can reply, so your inbox stays manageable.",
    lang: isSv ? "sv" : "en",
    canonical: isSv ? "/sv" : "/",
    hreflangEn: "/",
    hreflangSv: "/sv",
    image: "/og/entertainment.jpg",
    jsonLd: [buildLocalBusinessJsonLd(), buildOrganizationJsonLd(), buildWebsiteJsonLd()],
  });
  return (
    <PublicLayout>
      <Hero />
      <StatsBar />
      <HowItWorks3 />
      <BookingExample />
      <TrustBlock />
      <OfferSystem />
      <CategoryShortcuts />
      <SpotlightPreview />
      <TalentCta />
      <FinalCta />
    </PublicLayout>
  );
};

export default Home;
